import { render, staticRenderFns } from "./EditVideoDetails.vue?vue&type=template&id=4db742c8&"
import script from "./EditVideoDetails.vue?vue&type=script&lang=js&"
export * from "./EditVideoDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports